// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"472":"settings","594":"about"}[chunkId] + "." + {"472":"6ac5d886","594":"9329486e"}[chunkId] + ".js";
};